import { Notification, NOTIFICATION_TYPE } from './severe-collision-card.interface';

import { STEP_STATUS } from '@misc/steps/steps.component';

export const NOTIFICATION_STATUS = STEP_STATUS;

export const ALLOWED_COUNTRY_CODES: RegExp = /^(\+1|\+52|\+44)/;

export const EMS_NOTIFICATION_LABELS: Record<NOTIFICATION_TYPE, string> = {
  [NOTIFICATION_TYPE.GENERATED]: '',
  [NOTIFICATION_TYPE.INITIATED]: $localize`Call initiated with EMS`,
  [NOTIFICATION_TYPE.ERROR]: $localize`Technical error occurred`,
  [NOTIFICATION_TYPE.DISCONNECTED]: $localize`Call was disconnected before connecting to ECC`,
  [NOTIFICATION_TYPE.COMPLETED]: $localize`Call completed`,
};

export const PLACEHOLDER_NOTIFICATIONS: Partial<Record<NOTIFICATION_TYPE, Notification>> = {
  [NOTIFICATION_TYPE.INITIATED]:
    { status: NOTIFICATION_STATUS.WAIT, label: EMS_NOTIFICATION_LABELS[NOTIFICATION_TYPE.INITIATED] },
  [NOTIFICATION_TYPE.COMPLETED]:
    { status: NOTIFICATION_STATUS.WAIT, label: EMS_NOTIFICATION_LABELS[NOTIFICATION_TYPE.COMPLETED] },
};